import { TruckStatus, UliOrigin, UliStatus } from '../../common/constants/uli';
import {
  MonitoringFilterGateOption,
  MonitoringFilterPlantOption,
} from '../state/monitoring/models/monitoring-filter-plant-option.model';
import { ShipmentFilterName } from '../state/monitoring/shipment/constants';
import { ShipmentListFiltersETASources } from '../state/monitoring/models';
import { DeliveryService, Origin, ServiceLevel } from '../state/monitoring/transport/constants/transport-list.constant';
import { MonitoringFilterNameDictionary } from '../models/filter.model';
import { PartnerRegion } from '../state/administration/partner/constants/partner-region.constant';

export enum DraggableFilterType {
  Datepicker = 'DATEPICKER',
  Input = 'INPUT',
  Checkbox = 'CHECKBOX',
  BorderedCheckbox = 'BORDERED_CHECKBOX',
  CombinedRangeDatepicker = 'COMBINED_RANGE_DATEPICKER',
  RangeDatepicker = 'RANGE_DATEPICKER',
  Datetimepicker = 'DATETIMEPICKER',
  RangeDatetimepicker = 'RANGE_DATETIMEPICKER',
  MultipleSelect = 'MULTIPLE_SELECT',
  ChipsInput = 'CHIPS_INPUT',
  ChipsInputPopup = 'CHIPS_INPUT_POPUP',
  ChipsInputSearch = 'CHIPS_INPUT_SEARCH',
  ChipsInputSearchGeneric = 'CHIPS_INPUT_SEARCH_GENERIC',
  ChipsInputSearchGenericWithCheckboxes = 'CHIPS_INPUT_SEARCH_GENERIC_WITH_CHECKBOXES',
  CheckboxListPopup = 'CHECKBOX_LIST_POPUP',
  DropDownSelect = 'DROP_DOWN_SELECT',
  DropDownSearchSelect = 'DROP_DOWN_SEARCH_SELECT',
  RadioButtonListPopup = 'RADIO_LIST_POPUP',
  TimePicker = 'TIME_PICKER',
  MultipleDropDownSearchSelect = 'MULTIPLE_DROP_DOWN_SEARCH_SELECT',
  UppercaseInput = 'UPPERCASE_INPUT',
}

export enum FilterState {
  Enabled = 'ENABLED',
  Disabled = 'DISABLED',
}

export enum ProfileType {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
}

export enum ImmutableMonitoringListTitleFilter {
  BarcodeIds = 'barcodeIds',
  BoschOrderNumbers = 'boschOrderNumbers',
  BoschMaterialNumbers = 'boschMaterialNumbers',
  CustomerMaterialNumbers = 'customerMaterialNumbers',
  CustomerOrderNumbers = 'customerOrderNumbers',
  CarrierId = 'carrierId',
  CarrierNumber = 'carrierNumber',
  CarrierTOs = 'carrierTOs',
  Carriers = 'carriers',
  CommercialInvoiceNumbers = 'commercialInvoiceNumbers',
  CompartmentDockStructure = 'compartmentDockStructure',
  Consignees = 'consignees',
  ContractIdentifiers = 'contractIdentifiers',
  Consignors = 'consignors',
  CustomerOrderNumber = 'customerOrderNumber',
  DeliveryNoteNumbers = 'deliveryNoteNumbers',
  Email = 'email',
  EquipmentId = 'equipmentId',
  EquipmentIds = 'equipmentIds',
  FlightNumbers = 'flightNumbers',
  FreightPayers = 'freightPayers',
  BusinessUnits = 'businessUnits',
  HouseAirwayBills = 'houseAirwayBills',
  HouseBillOfLadings = 'houseBillOfLadings',
  HuIds = 'huIds',
  InboundPlants = 'inboundPlants',
  InboundRegions = 'inboundRegions',
  OutboundRegions = 'outboundRegions',
  IStarNumbers = 'iStarNumbers',
  Load = 'load',
  LoadNumbers = 'loadNumbers',
  LspTrackingNumbers = 'lspTrackingNumbers',
  MasterAirWaybills = 'masterAirWaybills',
  MasterBillOfLadings = 'masterBillOfLadings',
  MaterialNumbers = 'materialNumbers',
  MRPControllers = 'mrpControllers',
  Party = 'party',
  Pickups = 'pickups',
  Plants = 'plants',
  PurchaseOrderNumbers = 'purchaseOrderNumbers',
  RbPoNumber = 'rbPoNumber',
  RbPoNumbers = 'rbPoNumbers',
  ReasonCodes = 'reasonCodes',
  References = 'references',
  RouteIds = 'routeIds',
  SapIds = 'sapIds',
  SapInboundSystem = 'sapInboundSystem',
  SapPlantId = 'sapPlantId',
  SdOrderNumber = 'sdOrderNumber',
  ShipTos = 'shipTos',
  ShipperId = 'shipperId',
  StatusCodes = 'statusCodes',
  TimeFrame = 'timeFrame',
  TrailerPlates = 'trailerPlates',
  TransportNumbers = 'transportNumbers',
  TransportOrderNumbers = 'transportOrderNumbers',
  TransportReferences = 'transportReferences',
  TruckPlates = 'truckPlates',
  TruckPlate = 'truckPlate',
  Uli = 'uli',
  UnNumber = 'unNumber',
  UnNumbers = 'unNumbers',
  VesselNames = 'vesselNames',
  Waybills = 'waybills',
}

export const isFilterValueSentenceCase = [
  UliOrigin.WebApp,
  UliOrigin.GateApp,
  UliStatus.CalledToDock,
  UliStatus.CalledToWaitingArea,
  ...Object.values(TruckStatus),
];

export const isFilterValueUpperCase = [
  Origin.TMS,
  UliOrigin.Erp,
  UliOrigin.Srt,
  ShipmentListFiltersETASources.ML,
  ...Object.values(DeliveryService),
  ...Object.values(ServiceLevel),
];

export const TRANSLATED_FILTER_TITLES = new Map<string, string>([
  [TruckStatus.Init, `monitoring.allocationView.truckStatus.${TruckStatus.Init}`],
  [TruckStatus.Registered, `monitoring.allocationView.truckStatus.${TruckStatus.Registered}`],
  [TruckStatus.CalledToDock, `monitoring.allocationView.truckStatus.${TruckStatus.CalledToDock}`],
  [TruckStatus.CalledToArrivalSecurity, `monitoring.allocationView.truckStatus.${TruckStatus.CalledToArrivalSecurity}`],
  [TruckStatus.ArrivalSecurityFinished, `monitoring.allocationView.truckStatus.${TruckStatus.ArrivalSecurityFinished}`],
  [TruckStatus.ArrivedAtDock, `monitoring.allocationView.truckStatus.${TruckStatus.ArrivedAtDock}`],
  [TruckStatus.ReleasedFromDock, `monitoring.allocationView.truckStatus.${TruckStatus.ReleasedFromDock}`],
  [
    TruckStatus.CalledToSealPictureControl,
    `monitoring.allocationView.truckStatus.${TruckStatus.CalledToSealPictureControl}`,
  ],
  [
    TruckStatus.SealPictureControlFinished,
    `monitoring.allocationView.truckStatus.${TruckStatus.SealPictureControlFinished}`,
  ],
  [
    TruckStatus.DepartureSecurityFinished,
    `monitoring.allocationView.truckStatus.${TruckStatus.DepartureSecurityFinished}`,
  ],
  [TruckStatus.WaitingArea, `monitoring.allocationView.truckStatus.${TruckStatus.WaitingArea}`],
  [TruckStatus.PreparedForDeparture, `monitoring.allocationView.truckStatus.${TruckStatus.PreparedForDeparture}`],
  [TruckStatus.Departed, `monitoring.allocationView.truckStatus.${TruckStatus.Departed}`],
  [TruckStatus.Left, `monitoring.allocationView.truckStatus.${TruckStatus.Left}`],
  [TruckStatus.Geofence1, `monitoring.allocationView.truckStatus.${TruckStatus.Geofence1}`],
  [TruckStatus.Geofence2, `monitoring.allocationView.truckStatus.${TruckStatus.Geofence2}`],
  [TruckStatus.CalledToWaitingArea, `monitoring.allocationView.truckStatus.${TruckStatus.CalledToWaitingArea}`],
  [UliStatus.Registered, `monitoring.allocationView.loadStatus.${UliStatus.Registered}`],
  [UliStatus.CalledToDock, `monitoring.allocationView.loadStatus.${UliStatus.CalledToDock}`],
  [UliStatus.CalledToWaitingArea, `monitoring.allocationView.loadStatus.${UliStatus.CalledToWaitingArea}`],
  [UliStatus.Processed, `monitoring.allocationView.loadStatus.${UliStatus.Processed}`],
  [UliStatus.Loaded, `monitoring.allocationView.loadStatus.${UliStatus.Loaded}`],
  [UliStatus.Loading, `monitoring.allocationView.loadStatus.${UliStatus.Loading}`],
  [UliStatus.Unloaded, `monitoring.allocationView.loadStatus.${UliStatus.Unloaded}`],
  [UliStatus.Unloading, `monitoring.allocationView.loadStatus.${UliStatus.Unloading}`],
  [UliStatus.Deleted, `monitoring.allocationView.loadStatus.${UliStatus.Deleted}`],
  [UliStatus.Cleared, `monitoring.allocationView.loadStatus.${UliStatus.Cleared}`],
  [UliStatus.Geofence1, `monitoring.allocationView.loadStatus.${UliStatus.Geofence1}`],
  [UliStatus.Geofence2, `monitoring.allocationView.loadStatus.${UliStatus.Geofence2}`],
  [UliOrigin.WebApp, `monitoring.filters.uliOriginValues.${UliOrigin.WebApp}`],
  [UliOrigin.GateApp, `monitoring.filters.uliOriginValues.${UliOrigin.GateApp}`],
  [UliOrigin.EdiManager, `monitoring.filters.uliOriginValues.${UliOrigin.EdiManager}`],
  [UliOrigin.TMSEurolog, `monitoring.filters.uliOriginValues.${UliOrigin.TMSEurolog}`],
  [UliOrigin.Erp, `monitoring.filters.uliOriginValues.${UliOrigin.Erp}`],
  [UliOrigin.Srt, `monitoring.filters.uliOriginValues.${UliOrigin.Srt}`],
  [PartnerRegion.AF, `monitoring.filters.partnerRegion.${PartnerRegion.AF}`],
  [PartnerRegion.AP, `monitoring.filters.partnerRegion.${PartnerRegion.AP}`],
  [PartnerRegion.LA, `monitoring.filters.partnerRegion.${PartnerRegion.LA}`],
  [PartnerRegion.EMEA, `monitoring.filters.partnerRegion.${PartnerRegion.EMEA}`],
  [PartnerRegion.NA, `monitoring.filters.partnerRegion.${PartnerRegion.NA}`],
]);

export enum RecordTypeFilterKey {
  Plant = 'plant',
  GateName = 'gateName',
  Id = 'id',
  Name = 'name',
  Country = 'country',
  City = 'city',
  ExtId = 'extId',
  Abbreviation = 'abbreviation',
  CityName = 'cityName',
  SapSystem = 'sapSystem',
}

export const recordTypeFilterMap: Map<string, RecordTypeFilterKey[]> = new Map<string, RecordTypeFilterKey[]>([
  [ShipmentFilterName.ShipToPlants, [RecordTypeFilterKey.GateName]],
  [ShipmentFilterName.ConsigneePlants, [RecordTypeFilterKey.Plant]],
  [MonitoringFilterNameDictionary.SapIds, [RecordTypeFilterKey.Id]],
  [MonitoringFilterNameDictionary.BusinessUnits, [RecordTypeFilterKey.Id]],
  [MonitoringFilterNameDictionary.SapClientViews, [RecordTypeFilterKey.Name]],
  [MonitoringFilterNameDictionary.NetworkParts, [RecordTypeFilterKey.Id]],
  [
    MonitoringFilterNameDictionary.ConsignorAddresses,
    [RecordTypeFilterKey.Name, RecordTypeFilterKey.City, RecordTypeFilterKey.Country],
  ],
  [MonitoringFilterNameDictionary.FreightPayers, [RecordTypeFilterKey.ExtId, RecordTypeFilterKey.City]],
  [ShipmentFilterName.SourceLocations, [RecordTypeFilterKey.City]],
  [ShipmentFilterName.DestinationLocations, [RecordTypeFilterKey.City]],
  [ShipmentFilterName.PortsOfLoading, [RecordTypeFilterKey.Abbreviation, RecordTypeFilterKey.CityName]],
  [ShipmentFilterName.PortsOfDischarge, [RecordTypeFilterKey.Abbreviation, RecordTypeFilterKey.CityName]],
  [ShipmentFilterName.SapSystems, [RecordTypeFilterKey.SapSystem]],
]);

export type RecordTypeFilter = MonitoringFilterPlantOption | MonitoringFilterGateOption;

// TODO remove after id refactoring on back-end
export enum RecordTypeFilterOptionValueKey {
  GateAndPlantSapId = 'gateAndPlantSapId',
  SapPlantId = 'sapPlantId',
  Id = 'id',
  Name = 'name',
  Country = 'country',
  City = 'city',
  ExtId = 'extId',
  SapSystem = 'sapSystem',
}

export const chipsInputOptionValueMap: Map<string, RecordTypeFilterOptionValueKey[]> = new Map<
  string,
  RecordTypeFilterOptionValueKey[]
>([
  [ShipmentFilterName.ShipToPlants, [RecordTypeFilterOptionValueKey.GateAndPlantSapId]],
  [ShipmentFilterName.ConsigneePlants, [RecordTypeFilterOptionValueKey.SapPlantId]],
  [MonitoringFilterNameDictionary.SapIds, [RecordTypeFilterOptionValueKey.Id]],
  [MonitoringFilterNameDictionary.BusinessUnits, [RecordTypeFilterOptionValueKey.Id]],
  [MonitoringFilterNameDictionary.NetworkParts, [RecordTypeFilterOptionValueKey.Id]],
  [
    MonitoringFilterNameDictionary.ConsignorAddresses,
    [RecordTypeFilterOptionValueKey.Name, RecordTypeFilterOptionValueKey.Country, RecordTypeFilterOptionValueKey.City],
  ],
  [
    MonitoringFilterNameDictionary.FreightPayers,
    [RecordTypeFilterOptionValueKey.ExtId, RecordTypeFilterOptionValueKey.City],
  ],
  [ShipmentFilterName.SourceLocations, [RecordTypeFilterOptionValueKey.City]],
  [ShipmentFilterName.DestinationLocations, [RecordTypeFilterOptionValueKey.City]],
  [ShipmentFilterName.SapSystems, [RecordTypeFilterOptionValueKey.SapSystem]],
]);

export enum DaysFromToday {
  Today,
  TodayPlusOneDay,
  TodayPlusTwoDays,
  TodayPlusThreeDays,
}

export const searchCheckboxAutocompleteWidth: Map<ShipmentFilterName, string | number> = new Map<
  ShipmentFilterName,
  string | number
>([[ShipmentFilterName.ConsignorAddresses, 'auto']]);

export type SelectedItem<T> = T & { selected: boolean };

export enum BooleanValues {
  True = 'True',
  False = 'False',
}

export const chipsInputSplitPatternMap = new Map<ShipmentFilterName, RegExp>([
  [ShipmentFilterName.Carriers, /\s*[,;]\s*/],
  [ShipmentFilterName.Consignees, /\s*[,;]\s*/],
  [ShipmentFilterName.Pickups, /\s*[,;]\s*/],
  [ShipmentFilterName.ShipTos, /\s*[,;]\s*/],
  [ShipmentFilterName.VesselNames, /\s*[,;]\s*/],
]);
